import React from "react";

function Hero() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero" id="home">
      <div
        className="hero-bg"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
      <div className="hero-overlay"></div>
      <div className="hero-pattern"></div>
      <div className="hero-orb hero-orb-1"></div>
      <div className="hero-orb hero-orb-2"></div>
      <div className="hero-content">
        <div className="hero-eyebrow">✦ Best Spa Massages Parlor ✦</div>
        <h1 className="hero-title">
          Elevate Your
          <br />
          <em>Body & Mind</em>
          <br />
          With Our Spa
        </h1>
        <p className="hero-sub">
          Step into a haven of peace and indulgence, where every detail is
          crafted for your comfort and well-being. Come experience true
          relaxation today.
        </p>
        <div className="hero-btns">
          <button
            className="btn-primary"
            onClick={() => scrollToSection("services")}
          >
            Explore Services
          </button>
          <button
            className="btn-outline"
            onClick={() => scrollToSection("pricing")}
          >
            Our Treatments
          </button>
        </div>
      </div>
      <div className="hero-scroll">
        <div className="hero-scroll-text">Scroll to explore</div>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}

export default Hero;
